module.exports = __webpack_public_path__ + "static/media/circle.fe70f6e7.png";